<div class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 2607px;"></div>
  <div class="modal-dialog">
    <div class="modal-content" style="width: 550px;margin-left: 5%;    border-radius: 7px;">
      <div class="modal-header" style="color:white;line-height: 0.5;border-bottom: 1px solid var(--brand-primary-color);background: var(--brand-primary-color);border-top-right-radius: 7px;border-top-left-radius: 7px;">
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
        <div class="modal-title" style="font-weight: 500">
          <span style="margin-left: 10px;">{{ 'changeTransportOptionsFor' | translate }} <b>{{studentName}}</b>&nbsp; <span style="color: red;font-weight: bold;" *ngIf="academicYear">({{academicYear}})</span> &nbsp; <i *ngIf="isLoading" class="fa fa-spinner fa-spin" aria-hidden="true" style="vertical-align: middle"></i></span>
        </div>
      </div>
      <div class="modal-body">
        <!-- bus info -->
        <div class="row" style="margin: 0;min-height: 300px;">
          <div class="col-md-12">

            <div class="col-md-6">
              <div class="form-group">
                <select (change)="onChangeEditStudentStop(selectedStopId)" [(ngModel)]="selectedStopId" id="edit-student-bus-stop-fee-tr" name="select1" class="form-control" style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                  <option [value]="null">{{ 'notAssigned' | translate }}</option>
                  <option *ngFor="let stop of busStopListData" [value]="stop.PkBusStopId">{{stop.BusStopName}}({{stop.fare}} {{currType}})</option>
                </select>
                <label style="top: -20px !important;" for="edit-student-bus-stop-fee-tr">{{ 'selectStop' | translate }}</label>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <select id="edit-student-bus-selection-tr" [(ngModel)]="selectedBusId" name="select2" class="form-control" style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                  <option [value]="null">{{ 'notAssigned' | translate }}</option>
                  <option *ngFor="let b of busListData" [value]="b.pkBusId">{{b.BusName}}-{{b.BusNumber}}-{{b.RouteName}}({{b.startStop}} to {{b.endStop}})-(Capacity-{{b.Capacity}})-(Filled-{{b.assignedStudents}})</option>
                </select>
                <label style="top: -20px !important;" for="edit-student-bus-selection-tr">{{ 'selectBus' | translate }}</label>
              </div>
            </div>

            <div id="edit_student_busterm_layout" class="col-md-12 animated fadeInUp">
              <h5>{{ 'selectTerms' | translate }}:</h5>
              <label class="checkbox-inline checkbox-styled">
                <input type="checkbox" id="edit-student-selectAllTerms" (change)="onBusTermChangedSelectAll($event)" [(ngModel)]="selectAllTerms"><span>{{ 'selectAllTerms' | translate }} </span>
              </label>
              <div id="edit-student-termList">
                <label class="checkbox-inline checkbox-styled" *ngFor="let term of studentSelectedTerms">
                  <!--<span *ngFor="let term of studentSelectedTerms">-->
                  <input id="termList" type="checkbox" [checked]="term.isSelectedTerm" [disabled]="!term.isEditable" [value]="term.pkBusStopTermId" (change)="onBusTermChanged($event,term)">
                  <span>{{term.termName}} ({{'dueDate' | translate}}: {{term.termDueDate | date}})</span>
                  <!--</span>-->
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button style="background: var(--brand-primary-color);color: white" type="button" class="btn btn-raised btn-lg btn-block" [disabled]="isLoading" data-dismiss="modal" (click)="popupOkAction()">{{button_text}}</button>
      </div>
    </div>
  </div>
</div>
